import React from 'react';
import { Link } from "react-router-dom";
import {
  Calendar,
  UserPlus,
  FileText,
  Receipt,
  MapPin,
  BarChart3
} from "lucide-react";

// Simple components to replace Base44 imports
const Card = ({ children, className = "" }) => (
  <div className={`bg-white rounded-lg shadow-sm border ${className}`}>
    {children}
  </div>
);

const CardHeader = ({ children }) => (
  <div className="px-6 py-4 border-b">
    {children}
  </div>
);

const CardTitle = ({ children, className = "" }) => (
  <h3 className={`text-lg font-semibold ${className}`}>
    {children}
  </h3>
);

const CardContent = ({ children, className = "" }) => (
  <div className={`px-6 py-4 ${className}`}>
    {children}
  </div>
);

const Button = ({ children, className = "", variant = "default", ...props }) => (
  <button
    className={`px-4 py-2 rounded-lg font-medium transition-colors ${className}`}
    {...props}
  >
    {children}
  </button>
);

// Simple createPageUrl function
const createPageUrl = (page) => `/${page.toLowerCase()}`;

export default function QuickActions() {
  const actions = [
    {
      title: "Plan Visit",
      description: "Schedule new doctor visits",
      icon: Calendar,
      link: createPageUrl("Visits"),
      color: "bg-blue-500"
    },
    {
      title: "Add Doctor",
      description: "Register new doctor",
      icon: UserPlus,
      link: createPageUrl("Doctors"),
      color: "bg-green-500"
    },
    {
      title: "Daily Report",
      description: "Submit visit report",
      icon: FileText,
      link: createPageUrl("Reports"),
      color: "bg-purple-500"
    },
    {
      title: "Log Expense",
      description: "Record expenses",
      icon: Receipt,
      link: createPageUrl("Expenses"),
      color: "bg-orange-500"
    },
    {
      title: "Route Planning",
      description: "Optimize your routes",
      icon: MapPin,
      link: createPageUrl("Visits"),
      color: "bg-cyan-500"
    },
    {
      title: "Analytics",
      description: "View performance",
      icon: BarChart3,
      link: createPageUrl("Analytics"),
      color: "bg-pink-500"
    }
  ];

  return (
    <Card className="shadow-lg border-0 bg-white/80 backdrop-blur-sm">
      <CardHeader>
        <CardTitle className="text-xl font-bold text-gray-900">Quick Actions</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {actions.map((action, index) => (
            <Link key={index} to={action.link}>
              <Button
                className="h-auto flex-col gap-3 p-4 hover:bg-blue-50 transition-all duration-200 w-full"
              >
                <div className={`w-12 h-12 rounded-xl ${action.color} flex items-center justify-center`}>
                  <action.icon className="w-6 h-6 text-white" />
                </div>
                <div className="text-center">
                  <p className="font-medium text-gray-900 text-sm">{action.title}</p>
                  <p className="text-xs text-gray-500 mt-1">{action.description}</p>
                </div>
              </Button>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
